import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['Ana M.', 'Lucía R.', 'María C.', 'Sofía L.', 'Valentina P.', 'Camila S.', 'Isabella G.', 'Daniela M.', 'Fernanda T.', 'Gabriela O.', 'Paula J.', 'Martina B.', 'Elena V.', 'Julieta R.', 'Catalina D.'];
const CITIES = ['Buenos Aires', 'Santiago', 'Ciudad de México', 'Bogotá', 'Lima', 'Córdoba', 'Medellín', 'Guadalajara', 'Montevideo', 'Quito', 'Rosario', 'Valparaíso', 'Cali', 'Arequipa', 'Asunción'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerPopup();
    }, 5000);
    // Loop
    const interval = setInterval(() => {
      triggerPopup();
    }, Math.random() * (15000 - 8000) + 8000); // Random between 8-15s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerPopup = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-1">
      <div className="bg-white rounded-lg shadow-lg border border-blue-100 p-4 flex items-center gap-4 max-w-xs md:max-w-sm" data-id="element-2">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-3">
          <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-4" />
        </div>
        <div className="flex-1" data-id="element-5">
          <p className="text-sm font-medium text-gray-900" data-id="element-6">
            <span className="font-bold" data-id="element-7">{data.name}</span> de {data.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-8">
            compró{' '}
            <span className="font-semibold text-blue-600" data-id="element-9">TDAH MEGAPACK</span>{' '}
            hace unos instantes
          </p>
        </div>
        <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600" data-id="element-10">
          <X size={16} data-id="element-11" />
        </button>
      </div>
    </div>;
}